import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AnswerContainer from '../game/AnswerContainer';
import FishManager from '../game/FishManager';
import Friend from '../game/Friend';
import InstructionsShow from '../game/InstructionsShow';
import MessageGuy from '../game/MessageGuy';
import RoundIndicator from '../game/RoundIndicator';
import getUserData from '../game/UserData';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import ResultScreen from './ResultScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class CountFishScreen extends Phaser.Scene {
  static get KEY() { return 'CountFishScreen'; }

  init() {
    this.userData = getUserData();

    // this.userData.selectedFriend = 3; // uncomment this to test selected friend, change to 1/2/3 for different friends
    // this.userData.currentRound = 2; // uncomment this to test round, can change to 1/2/3
    // this.userData.playedInstructions = true; // uncomment this to skip instructions

    this.instructionsDisplay = null;

    this.curQuestion = null;
    this.questionCount = null;
    this.curRound = null;
    this.curMin = null;
    this.curMax = null;

    this.fishManager = null;
    this.answerDisplay = null;
    this.messageGuy = null;
    this.feedbackSound = null;
    this.roundIndicator = null;

    this.questionResultSet = null;

    this.friend = null;
    this.highlightedCount = null;

    this.seaMonster = null;
    this.seaMonsterShown = false;
    this.showingSeaMonster = false;
    this.monsterWidth = null;
    this.monsterQuestionNum = null;

    this.possibleSpawnRects = null;

    this.isQuitting = false;
  }

  create() {
    this.curQuestion = 0;
    this.questionCount = gameData.QUESTION_COUNT;
    this.curRound = this.userData.currentRound;
    this.questionResultSet = [];
    this.possibleSpawnRects = [];

    this.answerDisplay = new AnswerContainer(this);
    this.answerDisplay.on(AnswerContainer.ANSWER_CLICKED, this.handleAnswerClick, this);
    this.add.existing(this.answerDisplay);

    this.messageGuy = new MessageGuy(this);
    this.add.existing(this.messageGuy);

    this.fishManager = new FishManager(this);
    this.fishManager.on('FISH_HIGHLIGHTED', this.handleFishHighlighted, this);
    this.add.existing(this.fishManager);

    this.roundIndicator = new RoundIndicator(this, this.questionCount);
    this.roundIndicator.x = this.scale.width / 2 - this.roundIndicator.getBounds().width / 2;
    this.add.existing(this.roundIndicator);

    const fid = this.userData.getChosenFriend();
    if (fid > 0) {
      const startPositions = [{ x: 100,y: this.scale.height - 110 },{ x: 110,y: this.scale.height - 60 },{ x: 120,y: this.scale.height - 80 }];

      this.friend = new Friend(this, fid);

      this.friend.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.onPickupFriend(this.friend, pointer));
      this.friend.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.onMoveFriend(this.friend, pointer));
      this.friend.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => this.onReleaseFriend(this.friend));
      this.add.existing(this.friend);

      this.friend.x = startPositions[fid - 1].x;
      this.friend.y = startPositions[fid - 1].y;
    }
    this.seaMonster = ABCyaPhaser.Images.addImage(-500, 0, UIAssetKeys._SeaMonster, this).setOrigin(0);

    this.children.bringToTop(this.messageGuy);

    this.layoutRatio();

    this.initializeFishPossiblePositions();

    if (!this.userData.playedInstructions) {
      this.userData.playedInstructions = true;
      this.instructionsDisplay = new InstructionsShow(this, this.messageGuy);
      this.instructionsDisplay.once(InstructionsShow.INSTRUCTIONS_DONE, this.instructionsFinished, this, true);
      this.add.existing(this.instructionsDisplay);
      this.layoutRatio();
    }
    else {
      this.initializeRound();
    }

    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  handleAnswerClick (e) {
    const c = e.isCorrect;
    this.answerDisplay.isActive = false; // turn off answer buttons until after feedback

    this.questionResultSet[this.curQuestion].attempts++; // Store attempt count
    if (c) {
      this.roundIndicator.setIndicator(this.curQuestion, 'on');
      this.curQuestion++;
      if (this.curQuestion < this.questionCount) { // Checking for round over
        this.answerDisplay.doneWithAnswers(e.box);
        this.fishManager.scatterOffscreen();
        if (this.friend) this.friend.resetCount();
      }
      else {
        const roundResult = { score: 99, questionInfo: this.questionResultSet };
        this.answerDisplay.doneWithAnswers(e.box);
        this.userData.setRoundResults(roundResult);
        this.fishManager.scatterOffscreen();
      }
    }
    const numSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    numSound.once(Phaser.Sound.Events.COMPLETE, () => {
      numSound.destroy();
      this.playFeedbackSound({ dif: e.difference, isCorrect: c });
    });
    ABCyaPhaser.Audio.playSound(`Sound${e.num}`, numSound);
  }

  playFeedbackSound (data) {
    const dif = data.dif;
    let sndIndex;
    let thesound;
    const fntSize = 24;
    if (dif > 0) {
      sndIndex = Phaser.Math.Between(0,gameData.TOOMANY_SOUNDS.length - 1);
      thesound = gameData.TOOMANY_SOUNDS[sndIndex].snd;
      this.messageGuy.showMessage(ABCyaPhaser.Localization.instance.getLocalizedString(gameData.TOOMANY_SOUNDS[sndIndex].msg),fntSize);
    }
    else if (dif < 0) {
      sndIndex = Phaser.Math.Between(0,gameData.TOOFEW_SOUNDS.length - 1);
      thesound = gameData.TOOFEW_SOUNDS[sndIndex].snd;
      this.messageGuy.showMessage(ABCyaPhaser.Localization.instance.getLocalizedString(gameData.TOOFEW_SOUNDS[sndIndex].msg),fntSize);
    }
    else {
      sndIndex = Phaser.Math.Between(0,gameData.CORRECT_SOUNDS.length - 1);
      thesound = gameData.CORRECT_SOUNDS[sndIndex].snd;
      this.messageGuy.showMessage(ABCyaPhaser.Localization.instance.getLocalizedString(gameData.CORRECT_SOUNDS[sndIndex].msg),fntSize + 8);
    }
    if (thesound) {
      if (this.feedbackSound) {
        this.feedbackSound.destroy();
      }
      this.feedbackSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      this.feedbackSound.once(Phaser.Sound.Events.COMPLETE, () => this.answerDisplay.isActive = true);
      if (data.isCorrect) this.feedbackSound.once(Phaser.Sound.Events.COMPLETE, this.nextQuestion, this);
      ABCyaPhaser.Audio.playSound(thesound, this.feedbackSound);
    }
    else {
      this.answerDisplay.isActive = true;
    }
  }

  nextQuestion () {
    if (this.curQuestion + 1 === this.questionCount) {
      this.oneMore();
    }
    if (this.curQuestion < this.questionCount) {
      this.displayQuestion();
    }
    else {
      this.isQuitting = true;

      // there is a bug when destroying containers with sprites in them, causes issues with the update list... so we manually do it before quitting the scene
      this.fishManager.destroy();
      this.friend?.destroy();

      // after destroying those containers, we need to wait one frame and then clear the update list of the broken sprites that were added
      this.events.once(Phaser.Scenes.Events.POST_UPDATE, () => {
        for (let i = this.sys.updateList._active.length - 1; i >= 0; i--) {
          if (this.sys.updateList._active[i].scene === null || this.sys.updateList._active[i].scene === undefined) {
            this.sys.updateList._active.splice(i, 1);
          }
        }

        // then we can go to the next scene
        this.scene.start(ResultScreen.KEY);
      });
    }
  }

  oneMore () {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._counting_fish_04, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.messageGuy.showMessage(ABCyaPhaser.Localization.instance.getLocalizedString('one_more'), 24);
  }

  displayQuestion () {
    this.highlightedCount = 0;

    if (this.friend) this.friend.resetCount();
    const answer = Phaser.Math.Between(this.curMin,this.curMax);
    let answers = [];
    if (answer === 1) {
      answers = [answer,answer + 1,answer + 2];
    }
    else if (answer === this.curMax) {
      answers = [answer,answer - 1,answer - 2];
    }
    else {
      answers = [answer,answer - 1,answer + 1];
    }
    Phaser.Utils.Array.Shuffle(answers);
    const correctIndex = answers.indexOf(answer);
    this.answerDisplay.initializeAnswerSet(answers, correctIndex);

    let landingRects = this.possibleSpawnRects.slice();
    Phaser.Utils.Array.Shuffle(landingRects);
    landingRects = landingRects.splice(0,answer);

    this.fishManager.bringInCountedFish(answer, landingRects);
    this.questionResultSet[this.curQuestion].fishCount = answer;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fish_enter_scene, this);
    if (this.curQuestion + 1 === this.monsterQuestionNum) {
      this.answerDisplay.isActive = false;// turn it off until after the monster
      this.time.delayedCall(1200, this.showSeaMonster, null, this);
    }
  }

  showSeaMonster () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._jaws, this);
    this.seaMonster.x = -500;
    this.showingSeaMonster = true;
    this.seaMonsterShown = true;
  }

  handleFishHighlighted () {
    this.highlightedCount++;

    if (this.friend) this.friend.showCount(this.highlightedCount);
  }

  /**
   * 
   * @param {Friend} friend 
   * @param {Phaser.Input.Pointer} pointer 
   */
  onPickupFriend (friend, pointer) {
    const item = friend;
    item.offsetX = item.x - pointer.x;
    item.offsetY = item.y - pointer.y;
    item.pickup();
    this.friend.showCount(this.highlightedCount);
  }

  /**
   * 
   * @param {Friend} friend 
   * @param {Phaser.Input.Pointer} pointer 
   */
  onMoveFriend (friend, pointer) {
    const item = friend;
    const newx = pointer.x + item.offsetX;
    const newy = pointer.y + item.offsetY;
    if (newx < item.x - 1) {
      item.turnDir(-1);
    }
    else if (newx > item.x + 1) {
      item.turnDir(1);
    }
    item.x = newx;
    item.y = newy;
  }

  /**
   * 
   * @param {Friend} friend 
   */
  onReleaseFriend (friend) {
    const item = friend;

    // Make sure they are well within screen to make room for speech bubble
    let newX = 0;
    let newY = 0;

    const compareWidth = item.character.getBounds().width / 2;
    const compareHeight = item.character.getBounds().height / 2;

    if (item.x < compareWidth) {
      newX = compareWidth;
    }
    else if (item.x > this.scale.width - compareWidth) {
      newX = this.scale.width - compareWidth;
    }

    if (item.y < compareHeight + 160) {
      newY = compareHeight + 160;
    }
    else if (item.y > this.scale.height - compareHeight) {
      newY = this.scale.height - compareHeight;
    }

    let doMove = false;
    if (newX > 0 || newY > 0) doMove = true;
    if (doMove) {
      if (newX === 0) newX = item.x;
      if (newY === 0) newY = item.y;
      item.initializeSwimTo(newX,newY);
    }
    else {
      item.initializeHover();
    }
  }

  layoutRatio () {
    this.answerDisplay.x = this.scale.width / 2 + 40;
    this.answerDisplay.y = this.scale.height - 20;

    this.messageGuy.x = this.scale.width - this.messageGuy.getBounds().width - 20;
    this.messageGuy.y = this.scale.height - this.messageGuy.getBounds().height - 15;

    this.seaMonster.y = this.scale.height / 2 - this.seaMonster.height / 2;
    this.monsterWidth = this.seaMonster.width;
    this.initializeFishPossiblePositions();
  }

  initializeFishPossiblePositions () {
    this.possibleSpawnRects = [];

    // Things we don't wanna put the fish on
    const roundIndicatorRect = new Phaser.Geom.Rectangle(this.roundIndicator.x, this.roundIndicator.y, this.roundIndicator.getBounds().width, this.roundIndicator.getBounds().height);

    const spawnWidth = this.scale.width - 170;
    const spawnHeight = this.scale.height - 200; // Decided to just hardcode, nothing below the answers
    const boxW = 90;
    const boxH = 90;
    const rowCount = Math.floor(spawnWidth / boxW);
    const columnCount = Math.floor(spawnHeight / boxH);
    const totalWidth = rowCount * boxW;
    const x0 = (this.scale.width - totalWidth) / 2; const y0 = 40;
    let x1; let y1; let sR;
    for (let i = 0; i < rowCount; i++) {
      for (let j = 0; j < columnCount; j++) {
        x1 = x0 + boxW * i;
        y1 = y0 + boxH * j;

        sR = new Phaser.Geom.Rectangle(x1 + boxW / 2,y1 + boxH / 2, boxW, boxH);
        if (!Phaser.Geom.Rectangle.Overlaps(roundIndicatorRect,sR)) {
          this.possibleSpawnRects.push(sR);
        }
      }
    }
  }

  instructionsFinished () {
    this.instructionsDisplay.destroy();
    this.instructionsDisplay = null;
    this.initializeRound();
  }

  initializeRound () {
    this.monsterQuestionNum = Phaser.Math.Between(1,this.questionCount);
    for (let i = 0; i < this.questionCount; i++) {
      const v = { questionNum: i + 1, fishCount: 0, attempts: 0 };
      this.questionResultSet.push(v);
    }
    const roundInfo = gameData.ROUND_LEVEL_INFO[this.curRound - 1];
    this.curMin = roundInfo.min;
    this.curMax = roundInfo.max;

    this.curQuestion = 0;
    this.roundIndicator.initializeRound(this.curRound);
    this.displayQuestion();
  }

  update (time, delta) {
    if (this.isQuitting) return;

    const deltaInSeconds = delta / 1000;
    if (this.instructionsDisplay) this.instructionsDisplay.tick(deltaInSeconds);
    this.fishManager.tick(deltaInSeconds);
    if (this.friend) this.friend.tick(deltaInSeconds);
    if (this.showingSeaMonster) {
      this.seaMonster.x += deltaInSeconds + 8;
      if (this.seaMonster.x > this.scale.width) {
        this.answerDisplay.isActive = true;
        this.fishManager.returnScaredFish();
        this.showingSeaMonster = false;
      }
      else {
        this.fishManager.checkForFishToScare(this.seaMonster.x + this.monsterWidth + 50);
      }
    }
  }
}